const CONTACT_SERVER_URL = (process.env.REACT_APP_CONTACT_GIN1_URL || "").replace(/\/+$/, "");

export async function submitContactInquiry(inquiry) {
  if (!CONTACT_SERVER_URL) {
    throw new Error("Contact service is not configured.");
  }

  const response = await fetch(`${CONTACT_SERVER_URL}/inquiries/submit/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(inquiry),
  });

  let payload = {};
  try {
    payload = await response.json();
  } catch (error) {
    if (response.ok) {
      return {};
    }
  }

  if (!response.ok) {
    throw new Error(payload.message || "Your message could not be sent. Please try again.");
  }

  return payload;
}